import { render, staticRenderFns } from "./UpdateContactOtherPage.vue?vue&type=template&id=36055324&scoped=true"
import script from "./UpdateContactOtherPage.vue?vue&type=script&lang=js"
export * from "./UpdateContactOtherPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36055324",
  null
  
)

export default component.exports